
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

import { GenSyncUser } from './GenSyncUser';

export class GenSyncProject {

    archived: boolean;
    members: GenSyncUser[];
    name: string;
    notes: string;
    pointOfContact: GenSyncUser;
    roles: string[];
    slug: string;
    sourceProjectId: number;

    constructor();
    constructor( jsonObj: any );
    constructor( genSyncProject: GenSyncProject);

    constructor( input?: GenSyncProject ) {
        if ( input && typeof input !== 'number' ) {
            this.archived = input.archived; // boolean [boolean]
            if ( input.members && input.members.map ) { // list [GenSyncUser]
                this.members = input.members.map( ( x: GenSyncUser ) => {
                    return new GenSyncUser( x );
                } );
            } else {
                this.members = input.members;
            }
            this.name = input.name; // string [string]
            this.notes = input.notes; // string [string]
            if( input.pointOfContact ) {
              this.pointOfContact = new GenSyncUser( input.pointOfContact );
            }
            this.roles = input.roles; // list [string]
            this.slug = input.slug; // string [string]
            this.sourceProjectId = input.sourceProjectId; // int [number]
       }
    }

    static jsonResponseToList(arr: any[]): GenSyncProject[] {
        if (arr && arr.map) {
          return arr.map(a => new GenSyncProject(a));
        } else {
          return [];
        }
    }
}

